import { render, staticRenderFns } from "./UserNavMenu.vue?vue&type=template&id=6b8096ef&scoped=true&"
import script from "./UserNavMenu.vue?vue&type=script&lang=js&"
export * from "./UserNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserNavMenu.vue?vue&type=style&index=0&id=6b8096ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8096ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBarNavIcon,VBtn,VImg,VSpacer,VTab,VTabs,VToolbar})
